<script lang="ts">
    import { service } from "@frontend/services";
    import type { AddBannerDTO, ApiResultOfBannersDTO,  AuthenticatedRequestOfAddBannerDTO } from "@frontend/walletapi";
    import { translate, currentLanguage } from "../Translator";
    
    export let dismiss: () => void;
    
    let newBanner = {
        BanerName: '',
        Link: '',
        Enabled: true,
        BigSelect: '',
        SmallSelect: ''
    };
    

    let result: ApiResultOfBannersDTO | undefined = undefined;

    async function AddBanner() {
        const addBannerDTO: AddBannerDTO = {
            BannerName: newBanner.BanerName,
            Link: newBanner.Link,
            Enabled: newBanner.Enabled,
            BigSelect: newBanner.BigSelect,
            SmallSelect: newBanner.SmallSelect
        };

        const addBannerRequest: AuthenticatedRequestOfAddBannerDTO = {
            Token: sessionStorage.token,
            Data: addBannerDTO
        };

        try {
            result = await service.walletapi.addBanner(addBannerRequest);
            
            if (result.Success) {
                console.log("Banner added successfully:", result.Data);
                dismiss();
            } else {
                console.error("Error adding banner:", result.ErrorMessage);
            }
        } catch (error) {
            console.error("Error adding banner:", error);
        }
    }
</script>

<h2 class="ui centered dividing header">{$translate('Add Banner')}</h2>

{#if result && !result.Success}
    <div class="ui negative message">
        <div class="header">Error</div>
        <p>{result.ErrorMessage ?? "Unknown error when adding server"}</p>
    </div>
{/if}

<form class="ui form" on:submit|preventDefault={AddBanner}>
    <div class="field">
        <label for="">{$translate('Description')}</label>
        <input 
            type="text"
            bind:value={newBanner.BanerName}
            placeholder="Enter server label"
            required
        >
    </div>

    <div class="field">
        <label for="">{$translate('Link')}</label>
        <input 
            type="text"
            bind:value={newBanner.Link}
            placeholder="Enter username"
            required
        >
    </div>

    <div class="field">
        <label for="">{$translate('BigSelect')}</label>
        <input 
            type="text"
            bind:value={newBanner.BigSelect}
            placeholder="Enter password"
            required
        >
    </div>

    <div class="field">
        <label for="">{$translate('SmallSelect')}</label>
        <input 
            type="text"
            bind:value={newBanner.SmallSelect}
            placeholder="Enter server endpoint (IP or URL)"
            required
        >
    </div>

    <div class="two fields" style="display: flex">
        <button class="ui negative fluid button" type="button" on:click={dismiss}>{$translate('Cancel')}</button>
        <button class="ui positive fluid button" type="submit">{$translate('Add Banner')}</button>
    </div>
</form>
